<template>
  <a-form-item
    :label="label"
    class="imgcode"
    v-bind="$attrs"
  >
    <a-input
      v-decorator="decorator"
      :placeholder="placeholder"
      :maxlength="maxlength"
      style="width: 320px;"
    >
      <a-button
        slot="addonAfter"
        class="captcha-btn"
        @click="refreshCaptcha"
      >
        <img
          :src="captchaUrl"
          alt="验证码"
          title="点击刷新"
        >
      </a-button>
    </a-input>
  </a-form-item>
</template>

<script>

import { apiDomain } from '@/lib/config'
const CAPTCHA_URL = `${apiDomain}/user/common/image`

export default {
  name: 'CaptchaInput',
  inheritAttrs: false,
  props: {
    // 标签文本
    label: {
      type: String,
      default: ''
    },
    // v-decorator 配置
    decorator: {
      type: Array,
      default: () => ['captcha', { rules: [{ required: true, message: '请输入图片验证码' }] }]
    },
    // 验证码图片 URL
    src: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: '图片验证码'
    },
    maxlength: {
      type: [String, Number],
      default: 5
    }
  },
  data () {
    return {
      captchaUrl: `${CAPTCHA_URL}?t=${Date.now()}`
    }
  },
  mounted () {
    // this.refreshCaptcha()
  },
  methods: {
    refreshCaptcha () {
      // this.captcha = ''
      this.captchaUrl = `${CAPTCHA_URL}?t=${Date.now()}`
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep .ant-input-group-addon {
    border: none !important;
    border-radius: 0 !important;
  }
  .captcha-btn.ant-btn {
    border: none ;
    display: flex ;
    margin-right: 0 ;
    background: none ;
    padding: 0 ;
  }
</style>
